"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fender = void 0;
var React = __importStar(require("react"));
var material_1 = require("@mui/material");
var createStyles_1 = __importDefault(require("@mui/styles/createStyles"));
var classnames_1 = __importDefault(require("classnames"));
var color_1 = require("../core/style/color");
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var useStyles = function (iconSize) { return (0, makeStyles_1.default)(function (t) { return (0, createStyles_1.default)({
    root: {
        transition: t.transitions.create('all'),
        display: 'flex',
        textAlign: 'center',
        alignItems: 'center',
        justifyContent: 'center',
    },
    error: {
        color: color_1.colorError
    },
    empty: {
        color: t.palette.text.disabled
    },
    warning: {
        color: color_1.colorWarning
    },
    success: {
        color: color_1.colorSuccess
    },
    iContainer: {
        height: iconSize + 10,
        marginTop: t.spacing(1),
        lineHeight: 1,
    },
    i: {
        fontSize: iconSize + "px !important",
    },
    p: {
        marginTop: t.spacing(1),
    },
    title: {
        fontSize: 24,
    },
    description: {},
}); }); };
var Fender = function (_a) {
    var children = _a.children, icon = _a.icon, _b = _a.iconSize, iconSize = _b === void 0 ? 100 : _b, _c = _a.type, type = _c === void 0 ? 'empty' : _c, className = _a.className, style = _a.style, title = _a.title, description = _a.description;
    var classes = useStyles(iconSize)();
    var getIcon = function () {
        if (icon)
            return renderIcon(icon);
        switch (type) {
            case 'empty':
                return renderIcon('do_not_disturb');
            case 'error':
                return renderIcon('error_outline');
            case 'success':
                return renderIcon('check_circle_outline');
            case 'warning':
                return renderIcon('warning');
            case 'loading':
                return React.createElement(material_1.CircularProgress, { size: iconSize - 10 });
        }
    };
    var renderIcon = function (name) { return React.createElement(material_1.Icon, { className: classes.i }, name); };
    return (React.createElement("div", { className: (0, classnames_1.default)(classes.root, className), style: style },
        React.createElement("div", null,
            React.createElement("div", { className: (0, classnames_1.default)(classes.iContainer, classes[type]) }, getIcon()),
            React.createElement("div", { className: classes.p },
                title && React.createElement("div", { className: classes.title }, title),
                description && React.createElement("div", { className: classes.description }, description),
                children))));
};
exports.Fender = Fender;
//# sourceMappingURL=Fender.js.map